import React, { Component } from 'react';
import { DataSociete } from '../../data/DataSociete';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { DataOperation } from '../../data/DataOperation';

export class ComboBoxSociete extends Component {

    static defaultProps = {
        avecMandatSurLotDeLOperation: false,
        commercialisante: false,
        doitInclureEiffage: undefined,
        doitInclureExterne: undefined,
        doitInclureSocietesSansCompte: false,
        doitInclureSocietesSansMandat: false,
        idAgence: null,
        idLotCommercial: null,
        idOperation: null,
        idRegion: null,
        idReservation: null,
        idTypeMandat: undefined,
        label: "Société",
        listeIdContacts: null,
        placeholder: "Société",
    };

    render = () => {

        const {
            avecMandatSurLotDeLOperation,
            commercialisante,
            doitInclureEiffage,
            doitInclureExterne,
            doitInclureSocietesSansCompte,
            doitInclureSocietesSansMandat,
            idAgence,
            idLotCommercial,
            idOperation,
            idRegion,
            idReservation,
            idTypeMandat,
            listeIdContacts,
        } = this.props;

        let fetchMethod;
        let stamp;

        if (commercialisante) {
            fetchMethod = () => DataOperation._chargementSocietesCommercialisantes(idOperation, idReservation);
            stamp = [idOperation, idReservation];
        }
        else {
            if (idLotCommercial != null && idOperation != null) { //Option (FicheCommercialisateur) - Reservation (FicheCommercialisation)
                fetchMethod = () => DataSociete._chargementDesSocietesDontAuMoinsUnMandatEnglobeLeLotCommercial(idLotCommercial, idOperation);
                stamp = [idOperation, idLotCommercial];
            }
            //MG: 13/06/2022 - 2026 - Filtre Combo selon les regions et agences pour répartiteur
            else if (!!idRegion && !idAgence && !idOperation) //sociétés selon région
            {
                fetchMethod = () => DataSociete._chargementDesSocietesDontAuMoinsUnMandatEnglobeLaRegion(idRegion);
                stamp = [idRegion, idAgence, idOperation];
            }
            else if (!!idRegion && !!idAgence && !idOperation) //sociétés selon agence
            {
                fetchMethod = () => DataSociete._chargementDesSocietesDontAuMoinsUnMandatEnglobeLAgence(idRegion, idAgence);
                stamp = [idRegion, idAgence, idOperation];
            }
            else if (!!idOperation) //sociétés selon opération
            {
                fetchMethod = () => DataSociete._chargementDesSocietesDontAuMoinsUnMandatEnglobeLOperation(idOperation, avecMandatSurLotDeLOperation);
                stamp = [idRegion, idAgence, idOperation];
            }
            else if (idTypeMandat != undefined) { //TODO: pas testé
                fetchMethod = () => DataSociete._chargementDesSocietesParTypeMandat(idTypeMandat, doitInclureEiffage, doitInclureExterne);
                stamp = [idTypeMandat];
            }
            else if (doitInclureEiffage != undefined || doitInclureExterne != undefined) {
                fetchMethod = () => DataSociete._chargementDesSocietes(idTypeMandat, doitInclureEiffage, doitInclureExterne);
                stamp = [idTypeMandat];
            }
            else {
                fetchMethod = () => DataSociete._chargementDesSocietesDontAuMoinsUnMandatAppartientAmonPerimetre(listeIdContacts, doitInclureSocietesSansMandat, doitInclureSocietesSansCompte);
                stamp = [listeIdContacts];
            }
        }

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idSociete}
            itemText={item => item.nom}
            stamp={stamp}
        />;

    };

};
